import { Product } from "#/common/interfaces/conversionworld/Product";
// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export default class EmptyItem extends Vue {
  @Prop({ default: false })
  disabled!: Boolean;

  @Prop({ default: "van-add-next" })
  iconName!: string;

  public addItem() {
    this.$emit("addItem");
  }
}
